module.exports = __webpack_public_path__ + "static/img/answer-questionnaire4.488edf4.png";